// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PhoneInformationRequest } from './phone-information-request';

/** See com.rev360.pms.api.controller.patient.family.FamilyMemberContactInformationRequest */
/* istanbul ignore next */
@GandalfModel
export class FamilyMemberContactInformationRequest extends GandalfModelBase {

	@GandalfLabel('Email')
	@GandalfValidator({ sizeString: { message: 'Email cannot be longer than 100 characters', minLength: 0, maxLength: 100 } })
	@GandalfValidator({ email: { message: 'Invalid email format' } })
	@GandalfProperty({ designType: String })
	email!: string | null;

	@GandalfLabel('Email Declined')
	@GandalfProperty({ designType: Boolean })
	emailDeclined!: boolean | null;

	@GandalfLabel('Phone Numbers')
	@GandalfValidator({ notNull: { message: 'Phone Numbers is required' } })
	@GandalfProperty({ designType: PhoneInformationRequest, isRequired: true })
	phoneInformation!: PhoneInformationRequest;

}
